import { create } from "apisauce";

const api = create({
  baseURL: `${window.location.protocol}//${window.location.host}`,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export default class NotificationsApi {
  getToken = () => api.get("/stream/notifications/token");
}
